module.exports = {
  zcheck: {
    hd0: "Проверка заключений по QR-коду",
    hd1: "Заключение №",
    hd2: " от ",
    hd3: " найдено в базе данных лаборатории ООО &quot;SmartTeamDev&quot;",
    hd4: "Это заключение не найдено в базе данных лаборатории ООО &quot;SmartTeamDev&quot;",
    ls1: "Линия / узел / изделие: ",
    ls2: "Шифр проекта: ",
    ls3: "Группа технических устройств: ",
    ls4: "Заключение выдал дефектоскопист: ",
    ls5: "Метод контроля / Тип испытаний: ",
    lg1: "Проверка протокола лаборатории по его номеру",
    btn1: "Найти заключение",
    att1: "Вложения"
  },
  spfile: {
    zattachment: "Приложение к заключению",
    download: "Скачать файл",
    filenotfound: "Файл не найден",
    loading: "Загрузка данных...",
    openconclusion: "Показать данные протокола",
    error: "Ошибка загрузки файла",
    openfile: "Открыть файл"
  },
  pdf: {
    hd0: "Конвертация файлов Office в PDF",
    lb1: "* Поддерживаются файлы формата: DOC, DOCX, DOCM, RTF, XLS, XLSX, XLSM, JPEG, PNG",
    lb2: "Выбери файл (или перетащи файл сюда)",
    btn1: "ОТПРАВИТЬ"
  }
};
